var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamificationArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 24,
    transform: "matrix(1 0 0 -1 24 24)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5967 33C27.8087 33 28.012 32.9161 28.1619 32.7669C28.3118 32.6176 28.396 32.4152 28.396 32.2041V23.6483C28.3959 23.6221 28.401 23.5962 28.411 23.572C28.421 23.5478 28.4357 23.5258 28.4543 23.5073C28.4728 23.4888 28.4949 23.4742 28.5192 23.4642C28.5435 23.4543 28.5695 23.4492 28.5958 23.4493H31.1998C31.3595 23.4495 31.5156 23.402 31.648 23.313C31.7803 23.224 31.8829 23.0976 31.9424 22.95C32.0019 22.8025 32.0157 22.6405 31.9819 22.4851C31.9481 22.3296 31.8684 22.1878 31.7529 22.078L24.5523 15.2206C24.4036 15.079 24.2057 15 24 15C23.7943 15 23.5964 15.079 23.4477 15.2206L16.2471 22.078C16.1317 22.1878 16.0519 22.3295 16.0181 22.4849C15.9843 22.6402 15.998 22.8021 16.0574 22.9497C16.1169 23.0972 16.2193 23.2236 16.3515 23.3127C16.4838 23.4017 16.6398 23.4493 16.7994 23.4493H19.4042C19.4305 23.4492 19.4565 23.4543 19.4808 23.4642C19.5051 23.4742 19.5272 23.4888 19.5457 23.5073C19.5643 23.5258 19.579 23.5478 19.589 23.572C19.599 23.5962 19.6041 23.6221 19.604 23.6483V32.2041C19.604 32.4152 19.6882 32.6176 19.8381 32.7669C19.988 32.9161 20.1913 33 20.4033 33H27.5967Z",
    fill: "#EEF5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamificationArrow);
export default __webpack_public_path__ + "static/media/gamification-arrow.a06e93e9e8ac5f98bdaff7b0ac477cc8.svg";
export { ForwardRef as ReactComponent };